import React from 'react'
import {
  MenuControlsContainer,
  MenuButtonAddTable,
  MenuButtonBlockquote,
  MenuButtonBold,
  MenuButtonBulletedList,
  MenuButtonCode,
  MenuButtonCodeBlock,
  MenuButtonEditLink,
  MenuButtonHighlightColor,
  MenuButtonHorizontalRule,
  MenuButtonImageUpload,
  MenuButtonItalic,
  MenuButtonOrderedList,
  MenuButtonRedo,
  MenuButtonRemoveFormatting,
  MenuButtonStrikethrough,
  MenuButtonSubscript,
  MenuButtonSuperscript,
  MenuButtonTaskList,
  MenuButtonTextColor,
  MenuButtonUnderline,
  MenuButtonUndo,
  MenuButtonUnindent,
  MenuDivider,
  MenuSelectHeading,
} from 'mui-tiptap'
import type { ImageNodeAttributes } from 'mui-tiptap'
import { useTheme } from '@mui/material'
import { Editor } from '@tiptap/core'
import TextAlign from './TextAlign'
import FontSizeMenu from './FontSizeMenu'

// If your mui-tiptap version doesn't export ImageNodeAttributes, use:
// type ImageNodeAttributes = { src: string; alt?: string; title?: string; width?: number; height?: number }

type Props = {
  editor: Editor
  fontSizes: string[]
  fontSizeAnchor: null | HTMLElement
  setFontSizeAnchor: React.Dispatch<React.SetStateAction<null | HTMLElement>>
  openFontMenu: (el: HTMLElement) => void
  onUploadFiles: (files: File[]) => Promise<ImageNodeAttributes[]>
  forceExpand: () => void
  setFloatingOpen: (v: boolean) => void
  menuContainer?: HTMLElement | null
}
const TextEditorControls: React.FC<Props> = ({
  editor,
  fontSizes,
  fontSizeAnchor,
  setFontSizeAnchor,
  openFontMenu,
  onUploadFiles,
  forceExpand,
  setFloatingOpen,
  menuContainer,
}) => {
  const theme = useTheme()

  return (
    <MenuControlsContainer
      onClick={e => e.stopPropagation()}
      style={{
        width: '100%',
        justifyContent: 'space-between',
        padding: 0,
        margin: 0,
      }}
    >
      <MenuSelectHeading style={{ flexGrow: 1 }} />
      <MenuDivider />
      <MenuButtonAddTable />
      <MenuButtonBlockquote />
      <MenuButtonBold />
      <MenuButtonItalic />
      <MenuButtonUnderline />
      <MenuButtonTextColor />
      <FontSizeMenu
        editor={editor}
        fontSizes={fontSizes}
        fontSizeAnchor={fontSizeAnchor}
        setFontSizeAnchor={setFontSizeAnchor}
        openFontMenu={openFontMenu}
        forceExpand={forceExpand}
        setFloatingOpen={setFloatingOpen}
        container={menuContainer}
      />
      <TextAlign editor={editor} />
      <MenuButtonBulletedList />
      <MenuButtonCode />
      <MenuButtonCodeBlock />
      <MenuButtonEditLink />
      <MenuButtonHighlightColor />
      <MenuButtonHorizontalRule />
      <MenuButtonImageUpload onUploadFiles={onUploadFiles} inputProps={{ accept: 'image/*', multiple: true }} />
      {/* <MenuButtonIndent /> */}
      {/* <IncreaseIndentButton editor={editor} /> */}
      {/* <DecreaseIndentButton editor={editor} /> */}
      <MenuButtonOrderedList />
      <MenuButtonRemoveFormatting />
      <MenuButtonStrikethrough />
      <MenuButtonSubscript />
      <MenuButtonSuperscript />
      <MenuButtonTaskList />
      <MenuButtonRedo />
      <MenuButtonUndo />
      <MenuButtonUnindent />
      {/* <MenuSelectFontSize /> */}
    </MenuControlsContainer>
  )
}

export default TextEditorControls
